import React from 'react';
import ReactHighcharts from 'react-highcharts';

import { TopHolder } from "libs/api/invest/generated/schema";

import { toColor } from './utils';

export function HoldersPieChart(props: {
  holders: TopHolder[]
  chartWidth: number
  chartHeight: number
  label?: string
  dataTipFunction: CallableFunction
  showInLegend?: boolean
  dataLabels?: any
  valueField: string
}) {
  const chartConfig = () => {
    let data = normalizeData();
    return {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        type: 'pie',
        width: props.chartWidth,
        height: props.chartHeight,
      },
      title: {
        text: props.label,
        margin: 25,
      },
      tooltip: {
        style: {
          fontSize: 14,
        },
        pointFormat:
          typeof props.dataTipFunction == 'function'
            ? props.dataTipFunction()
            : '{series.name}: <b>{point.percentage:.2f}%</b>',
      },
      plotOptions: {
        pie: {
          showInLegend: props.showInLegend || false, // set this to true for legend
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: props.dataLabels || {
            enabled: false,
          },
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          // name: 'Brands',
          colorByPoint: true,
          data: data,
          shadow: true,
        },
      ],
    };
  };

  const percentToText = (value: number) =>
    `${(Math.round(value * 100) / 100).toLocaleString()}%`;

  const normalizeData = () => {
    const rows = props.holders;
    if (rows && rows.length > 0) {
      return rows.map((holder, index) => {
        let y = valueFunc(holder);
        let name = `<b>${holder.name}: ${percentToText(
          valueFunc(holder),
        )}</b>`;
        return {
          name: name,
          y: y,
          color: toColor(holder.color),
        };
      });
    }
  };

  const valueFunc = (item: any) => {
    let valueField = props.valueField || 'value';
    return item[valueField];
  };

  return <ReactHighcharts config={chartConfig()} />;
}
